import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import Benchmarks from '../components/Frontend/BenchmarkDetails/Benchmarks';
import { AccountContextProvider } from '../context/AccountContext';
// import { AccountListProvider } from '../context/AccountListContext';

export const benchmarksRoute = (
  <Route path="/benchmarks/:clientId/:clientName" element={<MainLayout />}>
    <Route 
      index 
      element={
        // <AccountListProvider>
          <Benchmarks />
        // </AccountListProvider>
      } 
    />
  </Route>
);
